import React, { Component } from 'react';
import PriceMatrixList from './PriceMatrixList';
import PriceMatrixSave from './PriceMatrixSave';
import WithRouter from 'custom/withRouter';

class PriceMatrixPage extends Component {
    constructor(props, context) {
        super(props, context);
    }

    //This page renders either Price Matrix List or Price Matrix Save
    render() {
        const p = this.props;
        const productId = p.params.id;
        const isSave = productId || p.location.pathname === "/priceMatrix/add";
        
        return (
            <React.Fragment>
                {
                    isSave
                        ?
                        <PriceMatrixSave
                            name="priceMatrixSave"
                            params={p.params} />
                        :
                        <PriceMatrixList title="List of Price Matrix" />
                }
            </React.Fragment>
        );
    }
}

export default WithRouter(PriceMatrixPage);